<div class="container-fluid">
  <div class="modal-header row">
    <div class="col">
      <div class="row">
        <div class="col">
          <h3>{{ title ? title : 'Upload File(s)' }}</h3>
        </div>
        <div class="col-auto">
          <button
            type="button"
            class="btn-close"
            aria-label="Close"
            (click)="close()"
          ></button>
        </div>
      </div>
      <div class="row">
        <div class="col">
          @if (helperText) {
            <div>
              <label>{{ helperText }}</label>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
  <div class="modal-body row">
    <app-file-upload-file-display
      [removeFileButtonText]="'DELETE'"
      [hideSelectFileButton]="true"
      [Files]="Files"
      (FileEvent)="fileUpload($event)"
      (removeFileEvent)="removeFile($event)"
    ></app-file-upload-file-display>
  </div>
  <div class="modal-footer row">
    <div class="col-2">
      <button type="button" class="btn btn-danger h-100" (click)="close()">
        Close
      </button>
    </div>
    <div class="col-2">
      <button type="button" class="btn btn-primary h-100" (click)="upload()">
        Upload
      </button>
    </div>
  </div>
</div>
